import { API_GET } from "../../config";

export const GetPrivateUser = (page) => {
  console.log(page)
  return API_GET(`/api/user/get-all?&count=${page}&account_type=1`);
};
